var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 576 377",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.933793,376.99828 L48.0662069,376.99828 C35.4234803,377.103968 23.2565864,372.18789 14.2423281,363.331618 C5.22806975,354.475346 0.104917102,342.404407 0,329.774494 L0,47.2254554 C0.104917102,34.5955425 5.22806975,22.524604 14.2423281,13.6683319 C23.2565864,4.81205985 35.4234803,-0.104018296 48.0662069,0.00166948646 L527.933793,0.00166948646 C540.57652,-0.104018296 552.743414,4.81205985 561.757672,13.6683319 C570.77193,22.524604 575.895083,34.5955425 576,47.2254554 L576,329.972913 C575.672786,356.195663 554.184273,377.218857 527.933793,376.99828 Z",
    id: "shape",
    fill: "#E8EBEE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#757575",
    strokeWidth: 20,
    x: 418,
    y: 58,
    width: 91,
    height: 63,
    rx: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#757575",
    x: 53,
    y: 208,
    width: 107,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#757575",
    x: 413,
    y: 208,
    width: 107,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#757575",
    x: 293,
    y: 208,
    width: 107,
    height: 40,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#757575",
    x: 173,
    y: 208,
    width: 107,
    height: 40,
    rx: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/Placeholder.553ba9929f8254aa344819b3fb7b5e05.svg";
export { ForwardRef as ReactComponent };